var _clipPath, _clipPath2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h650v350H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v150h650v150h-50zm0 300v50h300V0h300z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l600 300m0-300L0 300",
    stroke: "#fff",
    strokeWidth: 60,
    clipPath: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l600 300m0-300L0 300",
    stroke: "#c8102e",
    strokeWidth: 40,
    clipPath: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 150h650M300 0v350",
    stroke: "#fff",
    strokeWidth: 100
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 150h650M300 0v350",
    stroke: "#c8102e",
    strokeWidth: 60
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 300h600V0h600v600H0z",
    fill: "#009cde"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M645.34 490.913l29.436 90.597-77.066-55.992h95.26l-77.067 55.993zM817.462 464l-29.436 90.597L758.589 464l77.066 55.992h-95.26zm0-121.984l-29.436 90.597-29.437-90.597 77.066 55.992-95.26.001zm126.005 91.152l-29.437 90.597-29.436-90.597 77.066 55.992-95.26.001zm0-265.413l-29.437 90.597-29.436-90.597 77.066 55.992H866.4zm52.975 172.21l29.436 90.597-77.066-55.992h95.26l-77.067 55.993zm52.923-208.404l-29.437 90.597-29.437-90.597 77.067 55.992-95.26.001zm53.471 139.913l29.437 90.597-77.067-55.992h95.26l-77.067 55.993zm0-234.069l29.437 90.597-77.067-55.992h95.26l-77.067 55.993z",
    fill: "#fedd00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.2552574747183307bace87c3f67f07db.svg";
export { ForwardRef as ReactComponent };